import React, { useState, useEffect } from 'react';

const CodeMatrix = () => {
  const [matrix, setMatrix] = useState([]);
  const [currentScene, setCurrentScene] = useState(0);

  const techStack = [
    'Frontend', 'Backend', 'Mobile', 'Database', 'Cloud', 'System Design'
  ];

  const scenes = [
    { title: "INITIALIZING DEVELOPER...", subtitle: "Loading Abrar Shaikh" },
    { title: "SCANNING SKILLS...", subtitle: "Analyzing Tech Stack" },
    { title: "COMPILING EXPERIENCE...", subtitle: "Processing Projects" },
    { title: "DEPLOYMENT READY", subtitle: "Full Stack Developer" }
  ];

  useEffect(() => {
    // Create matrix effect
    const createMatrix = () => {
      const newMatrix = [];
      for (let i = 0; i < 50; i++) {
        newMatrix.push({
          id: i,
          text: techStack[Math.floor(Math.random() * techStack.length)],
          x: Math.random() * 100,
          y: Math.random() * 100,
          speed: Math.random() * 2 + 1,
          opacity: Math.random()
        });
      }
      setMatrix(newMatrix);
    };

    createMatrix();

    // Animate matrix
    const interval = setInterval(() => {
      setMatrix(prev => prev.map(item => ({
        ...item,
        y: (item.y + item.speed) % 110,
        opacity: Math.random() * 0.8 + 0.2
      })));
    }, 100);

    // Change scenes
    const sceneInterval = setInterval(() => {
      setCurrentScene(prev => (prev + 1) % scenes.length);
    }, 3000);

    return () => {
      clearInterval(interval);
      clearInterval(sceneInterval);
    };
  }, []);

  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'Courier New, monospace',
      padding: '0'
    }}>
      {/* Matrix Background */}
      {matrix.map(item => (
        <div
          key={item.id}
          style={{
            position: 'absolute',
            left: `${item.x}%`,
            top: `${item.y}%`,
            color: '#ffffff',
            fontSize: 'clamp(8px, 2vw, 12px)',
            opacity: item.opacity,
            transform: 'translateZ(0)',
            pointerEvents: 'none',
            textShadow: '0 0 10px rgba(255, 255, 255, 0.5)'
          }}
        >
          {item.text}
        </div>
      ))}

      {/* Scanlines */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `repeating-linear-gradient(
          0deg,
          transparent,
          transparent 2px,
          rgba(255, 255, 255, 0.03) 2px,
          rgba(255, 255, 255, 0.03) 4px
        )`,
        pointerEvents: 'none'
      }} />

      {/* Main Content */}
      <div style={{
        textAlign: 'center',
        zIndex: 10,
        background: 'rgba(0, 0, 0, 0.3)',
        padding: 'clamp(15px, 4vw, 40px)',
        margin: '0',
        borderRadius: 'clamp(15px, 3vw, 20px)',
        border: '2px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 0 40px rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        animation: 'pulse 2s infinite',
        maxWidth: 'min(90vw, 600px)',
        width: '100%',
        position: 'relative'
      }}>
        <div style={{
          fontSize: 'clamp(24px, 6vw, 48px)',
          color: '#ffffff',
          marginBottom: 'clamp(15px, 3vw, 20px)',
          textShadow: '0 0 20px rgba(255, 255, 255, 0.8)',
          letterSpacing: 'clamp(1px, 0.5vw, 3px)',
          lineHeight: '1.2'
        }}>
          {scenes[currentScene].title}
        </div>
        
        <div style={{
          fontSize: 'clamp(16px, 4vw, 24px)',
          color: '#ffffff',
          marginBottom: 'clamp(20px, 4vw, 30px)',
          opacity: 0.9,
          lineHeight: '1.3'
        }}>
          {scenes[currentScene].subtitle}
        </div>

        <div style={{
          fontSize: 'clamp(14px, 3vw, 18px)',
          color: '#ffffff',
          display: 'flex',
          justifyContent: 'center',
          gap: 'clamp(8px, 2vw, 20px)',
          flexWrap: 'wrap'
        }}>
          {techStack.map((category, index) => (
            <span
              key={category}
              style={{
                padding: 'clamp(6px, 1.5vw, 8px) clamp(12px, 3vw, 16px)',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                borderRadius: '8px',
                background: 'rgba(255, 255, 255, 0.1)',
                color: '#ffffff',
                animation: `fadeIn ${index * 0.2 + 1}s ease-in`,
                fontSize: 'clamp(12px, 2.5vw, 16px)',
                whiteSpace: 'nowrap'
              }}
            >
              {category}
            </span>
          ))}
        </div>


      </div>

      {/* CSS Animations */}
      <style>
        {`
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.02); }
          }
          
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
};

export default CodeMatrix;